"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegularCGPExecutor = void 0;
class RegularCGPExecutor {
    constructor(program, config) {
        this.program = program;
        this.config = config;
    }
    getNodeValue(nodeIdx, inputs) {
        const totalIdx = inputs.length + this.program.middleNodes.length;
        const effectiveIdx = nodeIdx % totalIdx;
        if (effectiveIdx < inputs.length) {
            return inputs[effectiveIdx];
        }
        // It's a middle node, so apply the operation:
        const middleNodeIdx = effectiveIdx - inputs.length;
        const middleNode = this.program.middleNodes[middleNodeIdx];
        // NOTE: Because this is "regular", left/right inputs are < current:
        const inputIndexes = middleNode.inputIndexes.map((i) => (i % effectiveIdx));
        const nodeInputs = inputIndexes.map((idx) => this.getNodeValue(idx, inputs));
        const effectiveOpIdx = middleNode.operator % this.config.operators.length;
        return this.config.operators[effectiveOpIdx](nodeInputs);
    }
    execute(inputs) {
        return this.program.outputs.map((outIdx) => {
            return this.getNodeValue(outIdx, inputs);
        });
    }
}
exports.RegularCGPExecutor = RegularCGPExecutor;
